export const appConfig = {
	buildingPermitsTitle: 'דרישות כבאות להיתרי בניה' ,
    businessLicensingTitle: 'דרישות כבאות לרישוי עסקים',
    assetRequirementTitle: 'דרישות לנכסים (שאינם טעוני רישוי)'
};



// WEBPACK FOOTER //
// ./src/assets/config/app.config.ts